import React, { createContext, useCallback, useContext, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { disconnectChatSocket } from "./chatSocket";
import LoginSheet from "../components/app-shell/LoginSheet";

const SessionContext = createContext(null);

// Holds the logged-in member and the shared login sheet, so any screen can
// read the member, ask them to log in, or log them out.
export function SessionProvider({ endUser, setEndUser, children }) {
  const navigate = useNavigate();
  const [loginOpen, setLoginOpen] = useState(false);

  const openLogin = useCallback(() => setLoginOpen(true), []);

  const logout = useCallback(() => {
    localStorage.removeItem("user-token");
    setEndUser(null);
    disconnectChatSocket();
    navigate("/");
  }, [navigate, setEndUser]);

  const value = useMemo(
    () => ({ endUser, setEndUser, openLogin, logout }),
    [endUser, setEndUser, openLogin, logout]
  );

  return (
    <SessionContext.Provider value={value}>
      {children}
      <LoginSheet open={loginOpen} onClose={() => setLoginOpen(false)} setEndUser={setEndUser} />
    </SessionContext.Provider>
  );
}

export function useSession() {
  return useContext(SessionContext);
}
